module.exports = __webpack_public_path__ + "img/1524482697.ff677b50.jpg";